import type { SelectHTMLAttributes } from "react";
import { cn } from "../../utils/cn";

type SelectProps = Omit<SelectHTMLAttributes<HTMLSelectElement>, "size"> & {
  hasError?: boolean;
  /** Density variant: "default" for forms, "compact" for dense UIs */
  size?: "default" | "compact";
};

const sizeClasses = {
  default: "h-11 text-sm px-3 rounded-md pr-10 bg-[length:1rem] bg-[position:right_0.75rem_center]",
  compact: "h-8 text-xs px-2.5 rounded pr-8 bg-[length:0.875rem] bg-[position:right_0.5rem_center]",
} as const;

export const Select = ({ className, hasError, size = "default", children, ...props }: SelectProps) => (
  <select
    className={cn(
      "border border-border bg-input text-foreground",
      sizeClasses[size],
      "transition-all duration-200",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
      "focus-visible:bg-[rgb(var(--focus))]",
      "appearance-none bg-no-repeat",
      "bg-[url('data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20stroke%3D%22%239ca3af%22%20stroke-width%3D%222%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%3E%3Cpolyline%20points%3D%226%209%2012%2015%2018%209%22%3E%3C%2Fpolyline%3E%3C%2Fsvg%3E')]",
      // Fix dropdown option styling for dark themes
      "[&>option]:bg-[rgb(var(--card))] [&>option]:text-[rgb(var(--foreground))]",
      "[&>optgroup]:bg-[rgb(var(--card))] [&>optgroup]:text-[rgb(var(--foreground))] [&>optgroup]:font-semibold",
      hasError && "border-destructive focus-visible:ring-destructive",
      className
    )}
    {...props}
  >
    {children}
  </select>
);
